var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortmbl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sort_by",
    "data-name": "Sort by",
    transform: "translate(-258 -121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3011",
    "data-name": "Rectangle 3011",
    width: 24,
    height: 24,
    transform: "translate(258 121)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-sort-4718162",
    transform: "translate(146.241 46.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34141",
    "data-name": "Path 34141",
    d: "M166.25,79.835v14.46a1.085,1.085,0,0,0,2.169,0V79.835a1.085,1.085,0,0,0-2.169,0Z",
    transform: "translate(-50.322)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34142",
    "data-name": "Path 34142",
    d: "M114.077,378.108l2.169,2.169a1.083,1.083,0,0,0,1.533,0l2.169-2.169a1.084,1.084,0,1,0-1.533-1.533l-1.4,1.4-1.4-1.4a1.084,1.084,0,0,0-1.533,1.533Z",
    transform: "translate(0 -285.216)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34143",
    "data-name": "Path 34143",
    d: "M324.835,395.919h8.676a1.085,1.085,0,1,0,0-2.169h-8.676a1.085,1.085,0,0,0,0,2.169Z",
    transform: "translate(-201.315 -301.986)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34144",
    "data-name": "Path 34144",
    d: "M324.835,290.919h7.23a1.085,1.085,0,1,0,0-2.169h-7.23a1.085,1.085,0,0,0,0,2.169Z",
    transform: "translate(-201.315 -201.324)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34145",
    "data-name": "Path 34145",
    d: "M324.835,185.919H329.9a1.085,1.085,0,1,0,0-2.169h-5.061a1.085,1.085,0,0,0,0,2.169Z",
    transform: "translate(-201.315 -100.662)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 0.4,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34146",
    "data-name": "Path 34146",
    d: "M324.835,80.919h2.892a1.085,1.085,0,0,0,0-2.169h-2.892a1.085,1.085,0,0,0,0,2.169Z",
    transform: "translate(-201.315)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 0.4,
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortmbl);
export default __webpack_public_path__ + "static/media/sortmbl.a0a00c39fdddccfc5cd7742541fae301.svg";
export { ForwardRef as ReactComponent };